import React, { Component, Fragment } from 'react';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import api, { apiResponseHandler, apiErrorHandler } from '../../services/AxiosService';
import authService from '../../services/AuthService';
import { isNullOrEmpty } from '../../helpers/LanguageHelpers';
import { apiErrorPopup } from '../../helpers/MessagePopup';

class AssessmentResultConfiguration extends Component {

    constructor(props) {
        super(props);

        this.state = {
            configurationItems: this.props.configurationItems
        }
    }

    updateConfigurationItemState = (itemDefId, newCheckState) => {
        // Update state with the new checked value
        let newConfig = [...this.state.configurationItems];
        let updateState = false;
        for (var i = 0; i < newConfig.length; i++) {
            if (newConfig[i].dynamicItemDefId == itemDefId) {
                newConfig[i].dynamicAssessmentItemIsChecked = newCheckState;
                updateState = true;
                break;
            }
        }
        if (updateState) {
            this.setState({ configurationItems: newConfig });
        }
    }

    assessmentConfigurationChangeHandler = (event) => {
        // Assessment and dyndefId separated by .
        let ids = event.target.id.split(".");
        // alert("assessment Id: " + ids[0] + ", dynDefId: " + ids[1] + "...state now " + event.target.checked);

        let newCheckState = event.target.checked;
        let url = "assessment/" + ids[0] + "/config/" + ids[1];
        api.post(url,
            {
                AssessmentId: ids[0],
                DynamicItemDefId: ids[1],
                NewValue: event.target.checked
            },
            {
                headers: {
                    Authorization: 'Bearer ' + authService.token
            }
        })
        .then(response => {
            if (response.status == 200) {
                // Update state with the new checked value
                this.updateConfigurationItemState(ids[1], newCheckState);
            }
            else {
                apiErrorPopup(apiResponseHandler(response));
                this.updateConfigurationItemState(ids[1], !newCheckState);
            }
        })
        .catch(error => {
            apiErrorPopup(apiErrorHandler(error));
            this.updateConfigurationItemState(ids[1], !newCheckState);
        });
    }

    render = () => {
        var numItems = (!isNullOrEmpty(this.state.configurationItems)) ? this.state.configurationItems.length : 0;
        let configItems = [];
        for (var index = 0; index < numItems; index++) {
            if (index % 3 == 0) {
                configItems = [...configItems,
                    (
                        <Row bsPrefix="home_noExpandCollapse row">
                            <Col bsPrefix="home_noExpandCollapse col" sm={4}>
                                <Form.Check
                                    type="checkbox"
                                    id={this.state.configurationItems[index].assessmentId + "." + this.state.configurationItems[index].dynamicItemDefId}
                                    className={(this.state.configurationItems[index].dynamicItemIsModifiable == true) ? "home_configItemTextActive home_noExpandCollapse" : "home_configItemTextDisabled home_noExpandCollapse"}
                                >
                                    <Form.Check.Input
                                        type="checkbox"
                                        className="home_noExpandCollapse"
                                        onChange={this.assessmentConfigurationChangeHandler}
                                        checked={(this.state.configurationItems[index].dynamicAssessmentItemIsChecked == true) ? true : false}
                                        disabled={(this.state.configurationItems[index].dynamicItemIsModifiable == true) ? false : true}
                                    />
                                    <Form.Check.Label className="home_noExpandCollapse" title={this.state.configurationItems[index].dynamicItemDescription}>{this.state.configurationItems[index].dynamicItemName}</Form.Check.Label>
                                </Form.Check>
                            </Col>
                            {index + 1 < numItems &&
                                <Col bsPrefix="home_noExpandCollapse col" sm={4}>
                                <Form.Check
                                    type="checkbox"
                                    id={this.state.configurationItems[index + 1].assessmentId + "." + this.state.configurationItems[index + 1].dynamicItemDefId}
                                    className={(this.state.configurationItems[index + 1].dynamicItemIsModifiable == true) ? "home_configItemTextActive home_noExpandCollapse" : "home_configItemTextDisabled home_noExpandCollapse"}
                                >
                                    <Form.Check.Input
                                        type="checkbox"
                                        className="home_noExpandCollapse"
                                        onChange={this.assessmentConfigurationChangeHandler}
                                        checked={(this.state.configurationItems[index + 1].dynamicAssessmentItemIsChecked == true) ? true : false}
                                        disabled={(this.state.configurationItems[index + 1].dynamicItemIsModifiable == true) ? false : true}
                                    />
                                    <Form.Check.Label className="home_noExpandCollapse"  title={this.state.configurationItems[index + 1].dynamicItemDescription}>{this.state.configurationItems[index + 1].dynamicItemName}</Form.Check.Label>
                                </Form.Check>
                            </Col>
                            }
                            {index + 2 < numItems &&
                                <Col bsPrefix="home_noExpandCollapse col" sm={4}>
                                <Form.Check
                                    type="checkbox"
                                    id={this.state.configurationItems[index + 2].assessmentId + "." + this.state.configurationItems[index + 2].dynamicItemDefId}
                                    className={(this.state.configurationItems[index + 2].dynamicItemIsModifiable == true) ? "home_configItemTextActive home_noExpandCollapse" : "home_configItemTextDisabled home_noExpandCollapse"}
                                >
                                    <Form.Check.Input
                                        type="checkbox"
                                        className="home_noExpandCollapse"
                                        onChange={this.assessmentConfigurationChangeHandler}
                                        checked={(this.state.configurationItems[index + 2].dynamicAssessmentItemIsChecked == true) ? true : false}
                                        disabled={(this.state.configurationItems[index + 2].dynamicItemIsModifiable == true) ? false : true}
                                    />
                                    <Form.Check.Label className="home_noExpandCollapse" title={this.state.configurationItems[index + 2].dynamicItemDescription}>{this.state.configurationItems[index + 2].dynamicItemName}</Form.Check.Label>
                                </Form.Check>
                            </Col>
                            }
                        </Row>
                    )
                ]
            }
        }

        return (
            <Fragment>
                {configItems}
            </Fragment>
        );
    }
}

export default AssessmentResultConfiguration;


// WEBPACK FOOTER //
// ./src/components/Home/AssessmentResultConfiguration.js